export default __webpack_public_path__ + "static/media/bg-discover.bd5a60d4.jpg";